/**
 * One-shot Recipient display for note success after checkout wipes the shopping session.
 *
 * Capture shipping name/lines at place time, then {@link resetCheckout}. Success paints from
 * this snapshot with no contact GET; clear when leaving success. Cold refresh falls back to
 * contact-by-id on the success page.
 */

export type HandwritingNoteSuccessRecipientSnapshot = {
    projectId: string
    contactName: string
    addressLines: string[]
}

let snapshot: HandwritingNoteSuccessRecipientSnapshot | null = null

/** Store Recipient display for the next success screen (overwrites any prior snapshot). */
export function captureHandwritingNoteSuccessRecipient(
    next: HandwritingNoteSuccessRecipientSnapshot
): void {
    const projectId = next.projectId.trim()
    if (!projectId) {
        snapshot = null
        return
    }
    snapshot = {
        projectId,
        contactName: next.contactName.trim() || 'Recipient',
        addressLines: next.addressLines.map((l) => l.trim()).filter(Boolean),
    }
}

/** Read snapshot when it matches `projectId`; otherwise null. */
export function peekHandwritingNoteSuccessRecipient(
    projectId: string
): HandwritingNoteSuccessRecipientSnapshot | null {
    const id = projectId.trim()
    if (!id || !snapshot || snapshot.projectId !== id) {
        return null
    }
    return snapshot
}

/** Drop the snapshot (leave success, new send, or abandon). */
export function clearHandwritingNoteSuccessRecipient(): void {
    snapshot = null
}
